import Vue from "vue";
import base from "../baseMarketing";

export default Object.assign(
    {
        apiUrl: "/account",

        async get({ accountId }) {
            const url = this.url(`/${accountId}/account-plan`);
            return Vue.http.get(url);
        },

        async link({ accountId, planId, smsAmount, addCreditToCurrentMonth }) {
            const url = this.url(`/${accountId}/account-plan`);

            return Vue.http.post(url, {
                planId,
                smsAmount,
                addCreditToCurrentMonth                
            });
        },

        async deleteLink({ accountId }) {
            const url = this.url(`/${accountId}/account-plan/`);

            return Vue.http.delete(url);
        },
    },
    base
);
